import gql from 'graphql-tag';
import {getPaymentInstructionsDocument} from 'graphql/generated-fbgraph/graphql';
import {Nullable} from 'js/reusable/types/general';
import client from 'js/tool/graphql/client/apollo';

export const ADD_DEPOSIT = gql`
	mutation createDeposit(
		$bankId: ID!,
		$externalAdAccounts: [depositExternalAdAccountInput],
		$depositPaymentType: PaymentType!,
		$depositDescription: String
	) {
		createDeposit(
			bankId: $bankId
			externalAdAccounts: $externalAdAccounts
			depositPaymentType: $depositPaymentType
			depositDescription: $depositDescription
		) {
			id: depositId
			depositInvoiceNumber
		    referenceNumber: depositReferenceNumber
		    referenceYear: depositReferenceYear
		    referenceFinal: depositReferenceFinal
		    entryDate: depositEntryDate
		    companyName: customerCompanyName
		    name: customerName
		    surname: customerSurname
		    email: customerEmail
		    amount: depositAmount
		    status: depositStatus
		    paymentType: depositPaymentType
		    note: depositDescription
		    address: customerAddress
		    city: customerCity
		    bankAccountNumber: bankAccountNumber
		    taxNumber: customerVatNumber
		    paymentDueTime: depositPaymentDueTime
		    discount: depositDiscount
		    taxPercentage: depositTaxPercentage
		    link: depositLink
		    minAmount: customerMinAmount
		    taUserAccountId: customerId
		    invoiceUrl: depositInvoiceUrl
		    description: depositDescription
		}
	}
`;

export function appendZeros(num: string, size: number) {
	if (num === undefined || num === null) {
		return '';
	}
	num = num.toString();

	while (num.length < size) {
		num = num + '0';
	}

	return num;
}

export async function downloadPaymentInstructionsDocument(documentName?: Nullable<string>, id?: Nullable<string>) {
	if (!documentName || !id) {
		return;
	}
	
	const {data} = await client.query({
		query:       getPaymentInstructionsDocument,
		variables:   {id},
		fetchPolicy: 'no-cache',
	});

	if (data && data.walletPaymentInstructions && data.walletPaymentInstructions.content) {
		const a = document.createElement('a');
		a.href = data.walletPaymentInstructions.content;
		a.download = documentName;
		a.click();
	}
}
